<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import api from '../api';

const route  = useRoute();
const router = useRouter();

const state = ref<'loading' | 'success' | 'error'>('loading');
const msg   = ref('');

onMounted(async () => {
  const token = route.query.token as string;
  if (!token) { state.value = 'error'; msg.value = 'No verification token provided.'; return; }
  try {
    await api.get(`customer/auth/verify-email?token=${encodeURIComponent(token)}`);
    state.value = 'success';
    setTimeout(() => router.push('/login'), 3000);
  } catch (err: any) {
    state.value = 'error';
    msg.value = err.response?.data?.message || 'Verification failed. The link may have expired.';
  }
});
</script>

<template>
  <div class="ve-wrap">
    <div class="ve-card">
      <div v-if="state === 'loading'" class="ve-state">
        <div class="ve-spinner"></div>
        <p>Verifying your email…</p>
      </div>
      <div v-else-if="state === 'success'" class="ve-state ve-state--ok">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#166534" stroke-width="2" stroke-linecap="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
        <h2>Email verified!</h2>
        <p>Redirecting you to login…</p>
      </div>
      <div v-else class="ve-state ve-state--err">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#9f1239" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>
        <h2>Verification failed</h2>
        <p>{{ msg }}</p>
        <a href="/login">Back to login</a>
      </div>
    </div>
  </div>
</template>

<style scoped>
.ve-wrap { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: #f8fafc; }
.ve-card { background: white; border-radius: 16px; padding: 48px 40px; text-align: center; max-width: 420px; width: 100%; box-shadow: 0 4px 24px rgba(0,0,0,.08); }
.ve-state { display: flex; flex-direction: column; align-items: center; gap: 16px; }
.ve-state h2 { font-size: 1.3rem; font-weight: 700; margin: 0; }
.ve-state p { color: #64748b; margin: 0; font-size: 14px; }
.ve-state--ok h2 { color: #166534; }
.ve-state--err h2 { color: #9f1239; }
.ve-state--err a { color: #0061eb; font-weight: 600; }
.ve-spinner { width: 40px; height: 40px; border: 3px solid #e2e8f0; border-top-color: #0061eb; border-radius: 50%; animation: spin .8s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }
</style>
